import React from 'react'
import { JSX } from 'react/jsx-runtime';

const AlarmClock = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clip-path="url(#clip0_383_544)">
        <path
          d="M11.7638 2.02728L11.7638 2.02728L11.7644 2.02776L12.9394 2.95276L12.9394 2.95279L12.9413 2.95419C13.0549 3.03941 13.2004 3.09919 13.3513 3.09919C13.5596 3.09919 13.7366 3.00803 13.8781 2.83821L13.8781 2.83822L13.8793 2.83666C14.1161 2.54076 14.054 2.12834 13.7637 1.8961L13.7637 1.89609L13.7623 1.89499L12.563 0.970519C12.2671 0.734483 11.8552 0.796665 11.6232 1.08672L11.623 1.08659L11.6193 1.09184C11.4132 1.3863 11.4738 1.79529 11.7638 2.02728Z"
          fill="#004E9B"
          stroke="#004E9B"
          stroke-width="0.2"
        />
        <path
          d="M3.06153 2.95419L3.06154 2.9542L3.06258 2.95339L4.26258 2.02839L4.26259 2.0284L4.264 2.02728C4.5543 1.79504 4.61634 1.38262 4.37962 1.08672C4.14744 0.796492 3.73516 0.734409 3.43927 0.970939C3.4392 0.970994 3.43913 0.971049 3.43906 0.971103L2.24168 1.91903C1.94609 2.12804 1.8897 2.54076 2.12077 2.83329C2.24319 3.01392 2.45134 3.09919 2.65153 3.09919C2.80236 3.09919 2.9479 3.03941 3.06153 2.95419Z"
          fill="#004E9B"
          stroke="#004E9B"
          stroke-width="0.2"
        />
        <path
          d="M12.1954 13.4336C13.5951 12.2404 14.475 10.468 14.475 8.5C14.475 4.91977 11.5802 2.025 8 2.025C4.41977 2.025 1.525 4.91977 1.525 8.5C1.525 10.4686 2.40543 12.2415 3.80586 13.4347L2.3261 15.0576L2.3261 15.0576L2.32526 15.0586C2.09102 15.3221 2.09086 15.7323 2.35429 15.9957C2.47587 16.1173 2.65277 16.175 2.8 16.175C2.97361 16.175 3.14999 16.1164 3.29571 15.9707L3.29578 15.9708L3.29867 15.9676L4.92019 14.2009C5.84262 14.71 6.88573 15 8.025 15C9.13971 15 10.206 14.7101 11.1298 14.2009L12.7492 15.9653C12.8759 16.1212 13.085 16.175 13.25 16.175C13.3964 16.175 13.5721 16.118 13.6936 15.9978C13.9573 15.7611 13.9874 15.3222 13.7218 15.0554L12.1954 13.4336ZM2.85 8.5C2.85 5.65523 5.15523 3.35 8 3.35C10.8448 3.35 13.15 5.65523 13.15 8.5C13.15 11.3448 10.8448 13.65 8 13.65C5.15523 13.65 2.85 11.3448 2.85 8.5Z"
          fill="#004E9B"
          stroke="#004E9B"
          stroke-width="0.2"
        />
        <path
          d="M10.9984 7.825H8.64844V5.575C8.64844 5.22261 8.35646 4.9 7.97344 4.9C7.62104 4.9 7.29844 5.19198 7.29844 5.575V8.5C7.29844 8.85239 7.59042 9.175 7.97344 9.175H10.9734C11.3258 9.175 11.6484 8.88302 11.6484 8.5C11.6484 8.12269 11.3565 7.825 10.9984 7.825Z"
          fill="#004E9B"
          stroke="#004E9B"
          stroke-width="0.2"
        />
      </g>
      <defs>
        <clipPath id="clip0_383_544">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AlarmClock